module.exports = __webpack_public_path__ + "img/gb853.prt.01e58f47.jpg";